<template>
    <b-container fluid>
        <header-buttons></header-buttons>
        <admin-contacts-table>
        </admin-contacts-table>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminContactsTable from "../components/AdminContactsTable";

    export default {
        name: "AdminContactsListView",
        components: {AdminContactsTable, HeaderButtons},
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
